import { render } from "./DialogDiscount.vue?vue&type=template&id=7bfd79f6&scoped=true"
import script from "./DialogDiscount.vue?vue&type=script&lang=js"
export * from "./DialogDiscount.vue?vue&type=script&lang=js"

import "./DialogDiscount.vue?vue&type=style&index=0&id=7bfd79f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bfd79f6"]])

export default __exports__